import {
  FirstOpenRecord,
  FirstOpenStorage,
  parseFirstOpenRecord,
} from '@griply/utils';

const firstOpenKey = 'first-open';

// The in-memory record keeps the once-only guard for this page load when localStorage is blocked
// (private mode, quota). It lives in a closure so a test can take a fresh instance instead of
// resetting the module graph, which re-resolves the whole @griply/utils barrel per test.
export const createFirstOpenStorage = (): FirstOpenStorage => {
  let inMemoryRecord: FirstOpenRecord | null = null;

  return {
    read: () => {
      try {
        return (
          parseFirstOpenRecord(window.localStorage.getItem(firstOpenKey)) ??
          inMemoryRecord
        );
      } catch {
        return inMemoryRecord;
      }
    },
    write: (record) => {
      inMemoryRecord = record;
      try {
        window.localStorage.setItem(firstOpenKey, JSON.stringify(record));
      } catch {
        // localStorage unavailable
      }
    },
  };
};

export const firstOpenStorage: FirstOpenStorage = createFirstOpenStorage();
